import { render } from "./SnackbarContainer.vue?vue&type=template&id=a7e05c66"
import script from "./SnackbarContainer.vue?vue&type=script&lang=js"
export * from "./SnackbarContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__